import { Component } from '@angular/core';
import { FieldWrapper, FormlyFieldConfig, FormlyFieldProps as CoreFormlyFieldProps, FormlyValidationMessage } from '@ngx-formly/core';

export interface FormlyFieldProps extends CoreFormlyFieldProps {
  hideRequiredMarker?: boolean;
  hideLabel?: boolean;
}

@Component({
  selector: 'formly-wrapper-offset-3',
  standalone: true,
  imports: [FormlyValidationMessage],
  template: `
    <div class="grid grid-cols-12 gap-2">
      @if (props.label && props.hideLabel !== true) {
        <label [for]="id" class="flex items-center col-start-4 col-span-9 mb-2 md:col-start-1 md:col-span-3 md:mb-0">
          {{ props.label }}
          @if (props.required && props.hideRequiredMarker !== true) {
            <span aria-hidden="true" class="text-red-500 ml-1">*</span>
          }
        </label>
      }

      <div class="col-start-4 col-span-9 md:col-start-4 md:col-span-9">
        <ng-container #fieldComponent></ng-container>
      </div>

      @if (showError) {
        <small class="p-error col-start-4 col-span-9 md:col-start-4 md:col-span-9">
          <formly-validation-message class="ui-message-text" [field]="field"></formly-validation-message>
        </small>
      }
    </div>
  `,
})
export class FormlyWrapperFormFieldOffset3 extends FieldWrapper<FormlyFieldConfig<FormlyFieldProps>> {
}
